document.addEventListener('DOMContentLoaded', ()=>{

  const targetNode = document.querySelector(".product__info-container");
  const config = { attributes: true, childList: true, subtree: true };
  const observedElements = new Set();
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        document.querySelectorAll('.bold_option_value input[type="checkbox"]').forEach((elm) => {
          if (!observedElements.has(elm)) {
            elm.addEventListener('click', (target) => {
              if( document.querySelectorAll(`.slider-section__wrapper.MainImage img[alt="${target.currentTarget.value}"]`).length > 0 ){
                 let MainImageAlt = document.querySelector(`.slider-section__wrapper.MainImage img[alt="${target.currentTarget.value}"]`).closest('.swiper-slide').getAttribute('mnmg');
                 MainImageAlt = parseInt(MainImageAlt);
                 MediaMainProductView.slideTo(MainImageAlt, 10, false);  
              }
            });
            observedElements.add(elm);
          }
        });
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

  if( window.screen.width > 749 ){
   var MediaThumbnailView = new Swiper('.swiper.slider-section__wrapper.Thumbnail', {
      slidesPerView: 5,direction: 'vertical',spaceBetween: 10,loop: false,navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},watchSlidesProgress: true,slideHeight: 200,
      on: {
        init: (swiper) => {
            if (document.querySelector('.slider-section__wrapper.Thumbnail').querySelector('.swiper-wrapper').childElementCount > 5){
              let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
              totalGap = parseInt(totalGap + 40);
              document.querySelector('.swiper.slider-section__wrapper.Thumbnail').style.height = totalGap+'px';
              window.addEventListener('resize', ()=>{
                let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;totalGap = parseInt(totalGap + 45);
                document.querySelector('.swiper.slider-section__wrapper.Thumbnail').style.height = totalGap+'px'; 
              });
            }else{
              let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
              totalGap = parseInt(totalGap + 65);
              document.querySelector('.swiper.slider-section__wrapper.Thumbnail').style.height = totalGap+'px';
              window.addEventListener('resize', ()=>{
                let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;totalGap = parseInt(totalGap + 65);
                document.querySelector('.swiper.slider-section__wrapper.Thumbnail').style.height = totalGap+'px'; 
              });              
            }
        }
      }     
    });
  }else{

   var MediaThumbnailView = new Swiper('.swiper.slider-section__wrapper.Thumbnail', {
      slidesPerView: 3,spaceBetween: 10,loop: false,navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},watchSlidesProgress: true,slideHeight: 200,
    });    
    
  }
  var MediaMainProductView = new Swiper('.swiper.slider-section__wrapper.MainImage',{autoHeight:true,centeredSlides: false,loop: false,slidesPerView: 1,spaceBetween: 15,watchOverflow: true,navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },thumbs: {swiper: MediaThumbnailView} });
  
  if( document.querySelectorAll('.slider_zoom__hardcode').length > 0 ){
    document.querySelectorAll('.MainImage img').forEach((elm)=>{
     elm.addEventListener('click', (evt)=>{
       evt.preventDefault();
       let Zoom$MediaMainProductView;
       let CurrentPopupChoosed = parseInt(evt.target.closest('.swiper-slide').getAttribute('mnmg'));
       Zoom$MediaMainProductView = new Swiper('.swiper.Zoom_slider-section__wrapper.Zoom_MainImage',{zoom: {maxRatio: 1.5}, slidesPerView: 1, watchOverflow: true, navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'} });
       Zoom$MediaMainProductView.slideTo(CurrentPopupChoosed, 10, true); 
       if( CurrentPopupChoosed == 0 ){ Zoom$MediaMainProductView.update(); }
       document.body.classList.add('zoomPopupActive');
     });
    });
    document.querySelector('.CrossZoomExt').addEventListener('click', (e)=>{
      e.preventDefault();
      document.body.classList.remove('zoomPopupActive');
    });
  }
})